export default "__VITE_ASSET__x6xPPBpA__"